import React from 'react';
import { useNavigate } from 'react-router-dom';
import image from 'assets/images/admin-forgot-password.png';
import { Col, Image, Row } from 'components';
import { ADMIN_ROUTES } from 'constants/routes';
import { PasswordSuccessResult } from 'components/auth';
import styles from '../signIn/styles.module.scss';

const PasswordSuccess: React.FC = () => {
  const navigate = useNavigate();

  const handleGoToSignIn = () => {
    navigate(ADMIN_ROUTES.adminSignIn);
  };

  return (
    <Row wrap={true} className={styles.signup} align={'middle'}>
      <Col lg={12} md={24}>
        <Row justify={'center'} className={styles.left_side}>
          <Col sm={15} xs={24} className={styles.form}>
            <PasswordSuccessResult
              title="Password Set Up Successfully"
              subtitle="Your password has been set up successfully. You can now sign in to your account."
              buttonText="Go to Sign In"
              onButtonClick={handleGoToSignIn}
            />
          </Col>
        </Row>
      </Col>
      <Col lg={12} md={24}>
        <Row className={styles.right_side}>
          <Image src={image} alt={'image'} preview={false} width={'100%'} />
        </Row>
      </Col>
    </Row>
  );
};

export default PasswordSuccess;
